import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GlobeIcon, LockIcon, ShieldIcon, ZapIcon } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
import { alsoIncluded, bonusList, mainSystem } from '../data/packageIncludes';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-navy" data-id="element-192" data-mp="1ja9x95bb50hh">
      <div className="max-w-3xl mx-auto" data-id="element-193" data-mp="1nbbuxhpkt4hc">
        <div className="text-center mb-10" data-id="element-194" data-mp="1naahj6l385wg">
          <p className="text-aqua font-semibold tracking-[0.2em] uppercase text-sm mb-3" data-id="element-195" data-mp="1s93y57vo8d0u">
            Your Complete Swim Teaching System
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-white" data-id="element-196" data-mp="1x9huvtrto0jk">
            Your Complete 6-in-1 Offer Today
          </h2>
          <p className="text-white/75 text-sm md:text-base" data-id="element-197" data-mp="2v8lvorjambz">
            Everything you need to plan less and teach with more structure.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white rounded-3xl p-6 md:p-10 text-center border-2 border-gold shadow-[0_16px_40px_rgba(8,24,50,0.35)]" data-id="element-198" data-mp="7vwe2dri197s">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy mb-3" data-id="element-199" data-mp="17sjvw6ypsy1k">
            Swim Instructor Ready
          </h3>
          <p className="text-base text-graphite mb-6" data-id="element-200" data-mp="25er925933ypj">
            The Complete 6-in-1 Swimming Teaching System — 120 ready-to-teach lessons across
            6 complete volumes, plus 5 premium bonus resources.
          </p>

          <div className="text-left max-w-md mx-auto mb-6 bg-pearl-light border border-pearl-dark rounded-xl p-5" data-id="element-201" data-mp="1rfrl6ztebnuf">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold-dark mb-3" data-id="element-202" data-mp="k1xu2xfb0a00">
              Main System
            </p>
            <ul className="space-y-2 mb-5" data-id="element-203" data-mp="fzt7gin9wdmv">
              {mainSystem.map(item => <li key={item} className="flex items-start gap-2 text-sm text-navy" data-id="element-204" data-mp="hit7fbyau29m">
                  <CheckIcon size={16} className="text-aqua-dark shrink-0 mt-0.5" data-id="element-205" data-mp="mh4g3jcuy6q9" />
                  <span data-id="element-206" data-mp="7ju4ma07t0uj">{item}</span>
                </li>)}
            </ul>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold-dark mb-3" data-id="element-207" data-mp="ciomn9qcyldl">
              Plus 5 Premium Bonuses
            </p>
            <ul className="space-y-2 mb-5" data-id="element-208" data-mp="3uvw8ot52r186">
              {bonusList.map(item => <li key={item} className="flex items-start gap-2 text-sm text-navy" data-id="element-209" data-mp="3j1w5iz62zzb">
                  <CheckIcon size={16} className="text-aqua-dark shrink-0 mt-0.5" data-id="element-210" data-mp="3kz06t69oldcl" />
                  <span data-id="element-211" data-mp="3pxbhtkbpptwe">{item}</span>
                </li>)}
            </ul>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold-dark mb-3" data-id="element-212" data-mp="3bxsa2smtckkm">
              Also Included
            </p>
            <ul className="space-y-2" data-id="element-213" data-mp="3fyc77w7dzo6r">
              {alsoIncluded.map(item => <li key={item} className="flex items-start gap-2 text-sm text-navy" data-id="element-214" data-mp="2xalblmeilf2m">
                  <CheckIcon size={16} className="text-aqua-dark shrink-0 mt-0.5" data-id="element-215" data-mp="2sc9zt64nsuhr" />
                  <span data-id="element-216" data-mp="36brshwl2srwe">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="mb-6" data-id="element-217" data-mp="31congc53ilof">
            <span className="text-lg text-graphite line-through block mb-1" data-id="element-218" data-mp="31bn9nzwp3l30">
              Regular Value: $105.00
            </span>
            <div className="flex items-baseline justify-center gap-2" data-id="element-219" data-mp="3g84ncxscxbsq">
              <span className="text-2xl md:text-3xl text-navy" data-id="element-220" data-mp="3b9t8g8n7gb3n">TODAY:</span>
              <span className="text-4xl md:text-5xl font-bold text-gold-dark" data-id="element-221" data-mp="3p2soqcuta9c9">$27.00</span>
            </div>
          </div>

          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-222" data-mp="3l1z17kla6wjw">
            GET THE COMPLETE 6-IN-1 SYSTEM NOW
          </Button>

          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-graphite mb-4" data-id="element-223" data-mp="3tzj7j7y03j1d">
            <span className="flex items-center gap-1.5" data-id="element-224" data-mp="lzo6h6cs7jl0">
              <LockIcon size={12} className="text-aqua-dark" data-id="element-225" data-mp="ly4pten7r6ip" /> Secure Payment
            </span>
            <span className="flex items-center gap-1.5" data-id="element-226" data-mp="qrpdodv3ek46">
              <ZapIcon size={12} className="text-aqua-dark" data-id="element-227" data-mp="vp7pqd4epfge" /> Instant Access
            </span>
            <span className="flex items-center gap-1.5" data-id="element-228" data-mp="3v4vyggpmtqir">
              <ShieldIcon size={12} className="text-aqua-dark" data-id="element-229" data-mp="3v6ffwan0y7m4" /> 7-Day Guarantee
            </span>
          </div>

          <div className="bg-pearl-light border border-pearl-dark rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-230" data-mp="32wgyf6nc88i">
            <GlobeIcon className="text-aqua-dark shrink-0 mt-0.5" size={14} data-id="element-231" data-mp="czj08zjbqr8f" />
            <p className="text-[11px] text-graphite leading-snug" data-id="element-232" data-mp="1jf23cwwjv81p">
              Pay in your local currency where available. The amount adjusts automatically
              based on your country.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}